<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>部门管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="onExportPage()"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary"
                   icon="sj-icon-add"
                   @click="$refs['formDialog'].show()"
                   size="small">添加
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <template v-for="(attr, index) of departmentJobFields">
          <el-table-column :key="index" v-bind="attr"></el-table-column>
        </template>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <form-dialog @submitted="onSearch" ref="formDialog" :params="{department_id}"/>
  </div>
</template>

<script>
import CompanyAccountManagementFormDialog from '../components/FinanceDepartmentJobFormDialog'
import financelConfigMixins from '../finance-config.mixins'
import { searchRules } from '../finance-config.rules'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker, financelConfigMixins],
  components: { FormDialog: CompanyAccountManagementFormDialog },
  data () {
    return {
      searchRules,
      department_id: this.$route.params.department_id,
      search: {
        id: null,
        department_id: this.$route.params.department_id,
        name: null,
      }
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getDepartmentJobLists', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.departmentJobFields,
        keyName: 'prop',
        labelName: 'label'
      })
    },
    enable (id) {
      this.$confirm('确认要启用吗?', '提示', {type: 'warning'}).then(() => {
        request.common('enableDepartmentJob', {id}).then(() => {
          this.$message.success('启用成功')
          this.onSearch()
        })
      }).catch(() => {
        this.$message.info('已取消该操作')
      })
    },
    disable (id) {
      this.$confirm('确认要禁用吗?', '提示', {type: 'warning'}).then(() => {
        request.common('disableDepartmentJob', {id}).then(() => {
          this.$message.success('禁用成功')
          this.onSearch()
        })
      }).catch(() => {
        this.$message.info('已取消该操作')
      })
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/FinanceDepartmentJobTable.vue